
import { Link } from 'react-router-dom';
import { Copyright } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { useTheme } from '@/contexts/ThemeContext';

export const Footer = () => {
  const { language } = useLanguage();
  const { theme } = useTheme();
  const currentYear = 2025;
  
  const logoSrc = theme === 'dark' 
    ? '/lovable-uploads/a0f0939a-3b33-4cf7-8f8d-85504e9ad117.png' 
    : '/lovable-uploads/ee1ae56d-3fb6-45ea-9a24-8cfa75082425.png';

  return (
    <footer className="border-t border-border/50 bg-card py-4">
      <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-between">
        <div className="flex items-center mb-2 sm:mb-0">
          <img 
            src={logoSrc} 
            alt="ReCut Logo" 
            className="h-6 w-auto mr-4" 
          />
          <span className="text-sm text-muted-foreground flex items-center">
            <Copyright className="h-4 w-4 mr-1" />
            {currentYear} ReCut. {language === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}
          </span>
        </div>
        
        <div className="flex items-center space-x-4">
          <Link 
            to="/privacy-policy" 
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            {language === 'fr' ? 'Politique de Confidentialité' : 'Privacy Policy'}
          </Link>
          
          <Link 
            to="/legal-notice" 
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            {language === 'fr' ? 'Mentions Légales' : 'Legal Notice'}
          </Link>
          
          <Link 
            to="/contact-us" 
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            {language === 'fr' ? 'Nous Contacter' : 'Contact Us'}
          </Link>
        </div>
      </div>
    </footer>
  );
};
